/**
 * « Programmes par niveau » de la page Abonnements d'un parent : quels niveaux
 * montrer, lequel ouvrir d'abord, et pour quel enfant acheter. PUR, testé.
 */

import { SCHOOL_LEVELS } from '@jeraisonne/db';

export interface LevelledChild {
  child_id: string;
  display_name: string | null;
  level: string | null;
}

/** Niveaux qui ont un programme, dans l'ordre scolaire (6e → prépa). */
export function programmeLevels(programmes: ReadonlyArray<{ level: string | null }>): string[] {
  const present = new Set(programmes.map((p) => p.level).filter((l): l is string => !!l));
  return SCHOOL_LEVELS.map((l) => l.value as string).filter((l) => present.has(l));
}

/** Niveau ouvert d'abord : celui d'un enfant lié s'il a un programme, sinon le 1er. */
export function defaultProgrammeLevel(
  levels: readonly string[],
  children: readonly LevelledChild[],
): string | null {
  const childLevel = children.map((c) => c.level).find((l) => !!l && levels.includes(l));
  return childLevel ?? levels[0] ?? null;
}

/** Premier enfant lié de ce niveau (achat direct pour lui), sinon null (carte cadeau). */
export function childForLevel(
  children: readonly LevelledChild[],
  level: string | null,
): LevelledChild | null {
  if (!level) return null;
  return children.find((c) => c.level === level) ?? null;
}

export function childFirstName(c: Pick<LevelledChild, 'display_name'>): string {
  return (c.display_name ?? '').trim().split(/\s+/)[0] || 'mon enfant';
}
